var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isPasswordStep)?_c('AdminPasswordEntry',{attrs:{"data-test-id":"adminPasswordEntry"},on:{"changeStep":_vm.handleComponentChange}}):_c('AdminEmailEntry',{attrs:{"data-test-id":"adminEmailEntry","errorParams":_vm.errorParams,"onError":_vm.onCredentialError},on:{"changeStep":_vm.handleComponentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }